import { combineReducers } from '@reduxjs/toolkit';
import deviceReducer from './deviceSlice';
import videoReducer from './videoSlice';
import intelligenceReducer from './intelligenceSlice';
import trackReducer from './trackSlice';
import alarmReducer from './alarmSlice';
import videoSwitchReducer from './videoSwitchSlice';
import algorithmReducer from './algorithmSlice';
import nvrReducer from './nvrSlice';

// 合并 ys7 模块下的所有 reducer
const ys7Store = combineReducers({
  device: deviceReducer,
  nvr: nvrReducer,
  video: videoReducer,
  intelligence: intelligenceReducer,
  track: trackReducer,
  alarm: alarmReducer,
  videoSwitch: videoSwitchReducer,
  algorithm: algorithmReducer
});

export default ys7Store;
